// src/features/landing/presentation/pages/PremiumPage.jsx
import React, { useState, useCallback, useEffect } from "react";
import { PremiumHeroSection } from "../components/PremiumHeroSection";
import { PremiumJobListingsSection } from "../components/PremiumJobListingsSection";
import { Footer } from "../components/Footer";
import { siteVisitRepository } from "../../infrastructure/siteVisitApiRepository";

import "../styles/landing.css";

export function PremiumPage() {
    const [filters, setFilters] = useState({
        companySido: "",
        jobType: "",
    });
    const [todayCount, setTodayCount] = useState(null);
    const [totalCount, setTotalCount] = useState(null);

    const handleSearch = useCallback((newFilters) => {
        setFilters(newFilters);
    }, []);

    useEffect(() => {
        const init = async () => {
            await siteVisitRepository.recordVisit('SITE');
            const today = new Date().toLocaleDateString('sv-SE');
            const data = await siteVisitRepository.getVisitStats(today, today);
            setTotalCount(data.siteTotalCount);
            const todayStat = data.dailyCounts.find(d => d.date === today);
            setTodayCount(todayStat ? todayStat.count : 0);
        };
        init().catch(() => {});
    }, []);

    return (
        <>
            <div style={{ paddingTop: '40px' }}>
                <PremiumHeroSection onSearch={handleSearch} />
                {(todayCount !== null || totalCount !== null) && (
                    <div style={{
                        background: '#fff',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '14px 20px',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                                <span style={{ fontSize: '1.4rem', fontWeight: 700, color: '#fd7314', lineHeight: 1.2 }}>
                                    {todayCount !== null ? todayCount.toLocaleString() : '-'}
                                </span>
                                <span style={{ fontSize: '0.75rem', color: '#888', fontWeight: 500 }}>오늘 방문자</span>
                            </div>
                            <div style={{ width: '1px', height: '34px', background: '#e9ecef' }} />
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
                                <span style={{ fontSize: '1.4rem', fontWeight: 700, color: '#fd7314', lineHeight: 1.2 }}>
                                    {totalCount !== null ? totalCount.toLocaleString() : '-'}
                                </span>
                                <span style={{ fontSize: '0.75rem', color: '#888', fontWeight: 500 }}>전체 방문자</span>
                            </div>
                        </div>
                    </div>
                )}
                <PremiumJobListingsSection filters={filters} />
            </div>
            <Footer />
        </>
    );
}
